module.exports = {
    i18n: {
        localeDetection: false,
        defaultLocale: 'en',
        locales: [
            'en',
            'de',
            'en-US',
            'de-DE',
            'en-DE',
            'en-AU',
            'en-CA',
            'en-GB',
        ]
    },
    async rewrites() {
        return [
            {
                source: '/:path([^\\/]*-[ac]\\d+)*',
                destination: '/list/:path*',
            },
            {
                source: '/:path([^\\/]*-p\\d+)*',
                destination: '/products/:path*',
            },
            {
                source: '/:path([^\\/]*-p\\d+-v\\d+)*',
                destination: '/products/:path*',
            },
        ]
    }
}